import {AdvertiserCampaignMediaModel} from './advertiser-campaign-media.model';
import {State} from '@ngxs/store';
import {MediaService} from '@services/media/media.service';
import {Observable, of} from 'rxjs';
import {IResponse} from '@interfaces/response';
import {IMediaItem} from '@interfaces/media';
import {tap} from 'rxjs/operators';
import {MediaTypeEnum} from '@shared/enums/media-type.enum';
import {Injectable} from '@angular/core';
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

@StateRepository()
@State<AdvertiserCampaignMediaModel>({
  name: 'advertiserCampaignMedia',
  defaults: {
    itemsPerPage: 7,
    search: '',
    media: [],
    totalMediaNum: 0,
    currentPage: 1,
    mediaType: null,
    order: '-created_at',
    selectedMedia: null,
    isDataLoading: false,
  }
})
@Injectable()
export class AdvertiserCampaignMediaState extends NgxsDataRepository<AdvertiserCampaignMediaModel> {
  constructor(private mediaService: MediaService) {
    super();
  }

  @DataActionWithoutSubscription({cancelUncompleted: true})
  getAdvertiserMedia(@Payload('[Advertiser campaign media] get medias for campaigns modal') payload?: { mediaType?: MediaTypeEnum, itemsPerPage?: number })
    : Observable<IResponse<IMediaItem>> {
    const limit = payload?.itemsPerPage || this.ctx.getState().itemsPerPage;
    const skip = limit * (this.ctx.getState().currentPage - 1);
    const search = this.ctx.getState().search;
    const mediaType = payload?.mediaType || this.ctx.getState().mediaType;
    const order = this.ctx.getState().order;

    this.ctx.patchState({isDataLoading: true});

    return this.mediaService.getAllMedia({
      limit,
      skip,
      order,
      search,
      media_type: mediaType || '',
    }).pipe(
      tap((media) => {
        this.ctx.setState({
          ...this.ctx.getState(),
          mediaType, isDataLoading: false, media: media.rows,
          totalMediaNum: media.total,
          itemsPerPage: limit
        });
      })
    );
  }

  @DataActionWithoutSubscription()
  advertiserSetMediaPage(@Payload('[Advertiser campaign media] set medias page for campaigns modal') page: number): Observable<any> {
    if (this.ctx.getState().currentPage === page) return of(null);
    this.ctx.patchState({currentPage: page});
    return this.getAdvertiserMedia();
  }

  @DataActionWithoutSubscription()
  advertiserSearchMedia(@Payload('[Advertiser campaign media] search medias in campaign modal') search: string): Observable<any> {
    this.ctx.patchState({search, currentPage: 1});
    return this.getAdvertiserMedia();
  }

  @DataActionWithoutSubscription()
  advertiserGetMediaByType(@Payload('[Advertiser campaign media] set media type in campaign modal') type: MediaTypeEnum): Observable<any> {
    this.ctx.patchState({mediaType: type, currentPage: 1, search: '', order: '-created_at'});
    return this.getAdvertiserMedia();
  }

  @DataActionWithoutSubscription()
  advertiserSortMedia(@Payload('[Advertiser campaign media] sort media in campaign modal') payload: { sort: string }): Observable<any> {
    this.ctx.patchState({order: payload.sort});
    return this.getAdvertiserMedia();
  }

  @DataActionWithoutSubscription()
  setSelectedMedia(@Payload('[Advertiser campaign media] set selected media') media: IMediaItem): void {
    this.ctx.patchState({selectedMedia: media});
  }

  @DataActionWithoutSubscription()
  sortMedias(@Payload('[Advertiser campaign media] sort media') order: string): Observable<any> {
    this.ctx.patchState({order});
    return this.getAdvertiserMedia();
  }
}
